import type { AxiosRequestConfig, Canceler } from 'axios';
import axios from 'axios';
import { isFunction } from '@/utils/is';

// 用于存储每个请求的唯一标识（method+url）和取消方法
let pendingMap = new Map<string, Canceler>();

// 获取请求唯一标识（method&url），用于区分不同请求
export const getPendingUrl = (config: AxiosRequestConfig) => [config.method, config.url].join('&');

export class AxiosCanceler {
  /**
   * 添加请求到 pendingMap（防止重复请求）
   * @param {object} config 请求配置
   */
  addPending(config: AxiosRequestConfig) {
    // 先移除同标识的旧请求，保证只保留最新的
    this.removePending(config);
    const url = getPendingUrl(config);
    // 设置 cancelToken，如果没有则新建一个
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (!pendingMap.has(url)) {
          // pendingMap 中没有当前请求，则添加
          pendingMap.set(url, cancel);
        }
      });
  }

  /**
   * 清空所有未完成的请求（如路由切换时调用）
   */
  removeAllPending() {
    pendingMap.forEach((cancel) => {
      cancel && isFunction(cancel) && cancel(); // 执行取消方法
    });
    pendingMap.clear(); // 清空 map
  }

  /**
   * 移除指定请求（请求完成或需要取消时调用）
   * @param {object} config 请求配置
   */
  removePending(config: AxiosRequestConfig) {
    const url = getPendingUrl(config);

    if (pendingMap.has(url)) {
      // pendingMap 中有当前请求标识，则取消并移除
      const cancel = pendingMap.get(url);
      cancel && cancel(url); // 执行取消方法
      pendingMap.delete(url); // 移除 map 项
    }
  }

  /**
   * 重置 pendingMap（全部清空，重新开始）
   */
  reset(): void {
    pendingMap = new Map<string, Canceler>();
  }
}
